import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'

export interface DeactivatePromotionCodeResult {
  deactivatePlusPromotionCodeV2:
    | {
        __typename: 'PlusPromotionCodeV2'
        id: string
        active: boolean
      }
    | {
        __typename: 'PlusPromotionCodeErrorV2'
        type: string
        error: string
      }
}

export interface DeactivatePromotionCodeVariables {
  id: string
}

const MUTATION = gql`
  mutation DeactivatePlusPromotionCode($id: String!) {
    deactivatePlusPromotionCodeV2(id: $id) {
      ... on PlusPromotionCodeV2 {
        id
        active
      }
      ... on PlusPromotionCodeErrorV2 {
        type
        error
      }
    }
  }
`

export const useDeactivatePromotionCode = () => {
  return useMutation<DeactivatePromotionCodeResult, DeactivatePromotionCodeVariables>(MUTATION)
}
